import { render, staticRenderFns } from "./AppConfigureContacts.js.vue?vue&type=template&id=a74c3322&scoped=true"
import script from "./AppConfigureContacts.js.vue?vue&type=script&lang=js"
export * from "./AppConfigureContacts.js.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a74c3322",
  null
  
)

export default component.exports